import { Button } from '@factorialco/factorial-one-react'
import { InAppCommsButton } from 'generated/resources/graphql'

import { track, trackingEvents } from 'modules/core/lib/Tracking'

import {
  isValidFeature,
  isValidModule,
  isValidReason,
} from 'modules/in_app_comms/lib/enumValidation'
import useCreateUpsellRequest from 'modules/upsell/hooks/useCreateUpsellRequest'

import UpsellButton from './_UpsellButton'

interface ButtonProps {
  button: InAppCommsButton
  variant: string
  size: string
  componentType: string
  componentName: string
  onClick?: () => void
  extraEventProps?: Record<string, string>
}

const CommsButton = ({
  button,
  onClick,
  variant,
  size,
  componentType,
  componentName,
  extraEventProps,
}: ButtonProps) => {
  const { create } = useCreateUpsellRequest()

  const triggerEvent = (action: string) => {
    track(trackingEvents.inAppComms.clickInAppCommsComponent, {
      componentType,
      componentName,
      buttonType: button.type,
      buttonAction: action,
      ...extraEventProps,
    })
  }

  if (!button) return null

  switch (button.type) {
    case 'CommsLinkButtonRecord':
      return (
        <Button
          label={button.text}
          onClick={() => {
            triggerEvent(`Open link: ${button.link}`)
            if (button.openInNewTab) {
              window.open(button.link || '', '_blank')
            } else {
              window.location.href = button.link || ''
            }
            onClick?.()
          }}
          variant={variant}
          size={size}
        />
      )

    case 'CommsCloseButtonRecord':
      return (
        <Button
          label={button.text}
          onClick={() => {
            triggerEvent('Close component')
            onClick?.()
          }}
          variant={variant}
          size={size}
        />
      )

    case 'CommsUpsellButtonRecord':
      return (
        <UpsellButton
          size={size}
          label={button.text}
          onClick={async () => {
            const upsellProps = {
              moduleRequested: isValidModule(button.moduleRequested)
                ? button.moduleRequested
                : undefined,
              requestSource: button.requestSource || undefined,
              requestReason: isValidReason(button.requestReason) ? button.requestReason : undefined,
              featureRequested: isValidFeature(button.featureRequested)
                ? button.featureRequested
                : undefined,
            }

            await create(upsellProps)

            track(trackingEvents.inAppComms.clickInAppCommsComponent, {
              componentType,
              componentName,
              buttonType: button.type,
              buttonAction: 'Upsell request',
              ...upsellProps,
            })
            onClick?.()
          }}
        />
      )

    default:
      return (
        <Button
          label={button.text}
          onClick={() => {
            triggerEvent('Default on click')
            onClick?.()
          }}
          variant={variant}
          size={size}
        />
      )
  }
}

export default CommsButton
